import { useWorkspaceNavPushMode } from '~/components/v2/hooks/useWorkspaceNavPushMode';
import { getWorkspaceSelectionBarZIndexClass } from '~/components/v2/utils/getWorkspaceSelectionBarZIndexClass';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

/** Wires workspace nav + ui2026 flags into {@link getWorkspaceSelectionBarZIndexClass}. */
export const useWorkspaceSelectionBarZIndexClass = () => {
  const { isWorkspaceNavPushMode } = useWorkspaceNavPushMode();
  const { ui2026 } = useTemporaryFeatureFlags();

  return {
    selectionBarZIndexClass: getWorkspaceSelectionBarZIndexClass({ isWorkspaceNavPushMode, ui2026 }),
  };
};
